import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchBarComponent } from './search-bar.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonNgxBootstrapModule } from '../common-ngx-bootstrap/common-ngx-bootstrap.module';
import { MessageFilterPanelComponent } from './message-filter-panel/message-filter-panel.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        CommonNgxBootstrapModule
    ],
    declarations: [
        SearchBarComponent,
        MessageFilterPanelComponent
    ],
    exports: [
        SearchBarComponent
    ]
})
export class SearchBarModule { }
